export default "__VITE_ASSET___xqxiIjN__"